import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseItemModelService } from './base-item.model';
import { ImageItemModelService } from './image-item.model';
import { SimpleTextModelService } from './simple-text.model';
import { SiteMapItemModelService } from './site-map-item.model';
import { DocumentTemplateListDataService } from '../document-template/document-template-list-data.service';
import { TemplateLayoutService } from './template-layout.service';
import { AdvancedTextModelService } from './advanced-text.model';
import { TemplateLayoutLanguageService } from './template-layout-language.service';

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [
        BaseItemModelService,
        SimpleTextModelService,
        AdvancedTextModelService,
        ImageItemModelService,
        SiteMapItemModelService,
        DocumentTemplateListDataService,
        TemplateLayoutService,
        TemplateLayoutLanguageService,
    ],
})
export class TemplateModule {}
